// @ts-nocheck
// Exact live (2026-10-15) version restored from the production sourcemap.
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Dialog, IconButton, Typography } from '@mui/material';
import { CloseCircle, Edit } from 'iconsax-react';
import { WidgetHeader } from '../../../../components/common/header/widgetHeader/WidgetHeader';
import { CustomChip } from '../../../../components/common/chip/Chip';
import { PrimaryGrid } from '../../../../components/common/grid/PrimaryGrid';
import { useAppSelector } from '@application/store/useStore';
import { HoursStatus } from '@application/common/enums/hours-status';
import { ClientContractStatus } from '@application/common/enums/client-contract-status';
export const OpenTimSheet = ({ open, handleClose, onEdit }) => {
    const { timeSheetWithClientInfo } = useAppSelector((state) => state.timeSheet);
    const columns = [
        {
            field: 'monthName',
            headerName: 'Timesheets',
            flex: 2
        },
        {
            field: 'allClientNames',
            headerName: 'Client',
            flex: 2
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 2,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => _jsx(CustomChip, { value: params.value })
        },
        {
            field: 'action',
            headerName: 'Edit',
            flex: 0.5,
            renderCell: (params) => (_jsx(IconButton, { disabled: params.row.assignmentStatus === ClientContractStatus.Expired, onClick: () => {
                    handleEdit(params);
                }, children: _jsx(Edit, {}) }))
        }
    ];
    const rows = timeSheetWithClientInfo?.timeSheetWithClientInfo.map((data, index) => {
        return {
            id: index + 1,
            monthName: data.monthName,
            allClientNames: data.assignmentStatus == ClientContractStatus.Expired ? `${data.allClientNames} (Expired)` : data.allClientNames,
            status: `${HoursStatus[data.timeSheetStatus]}`,
            month: data.month,
            year: data.year,
            assignmentId: data.assignmentId,
            assignmentStatus: data.assignmentStatus
        };
    });
    const handleEdit = (params) => {
        const editData = { Month: params.row.month, Year: params.row.year, AssignmentId: params.row.assignmentId };
        onEdit(editData);
    };
    return (_jsxs(Dialog, { open: open, onClose: handleClose, maxWidth: false, BackdropProps: {
            sx: {
                backdropFilter: 'blur(3px)',
                backgroundColor: 'rgba(74, 74, 74, 0.25)'
            }
        }, PaperProps: {
            sx: {
                width: '620px',
                maxHeight: '90vh',
                overflow: 'hidden'
            }
        }, children: [_jsx(Box, { sx: {
                    position: 'sticky',
                    top: 0,
                    zIndex: 2,
                    backgroundColor: 'white'
                }, children: _jsxs(WidgetHeader, { background: 'white', children: [_jsx(Typography, { fontSize: '20px', color: 'black', sx: {
                                whiteSpace: 'normal',
                                wordBreak: 'break-word'
                            }, children: "Open timesheets" }), _jsx(IconButton, { onClick: handleClose, sx: { padding: { xs: '0px', md: '8px' } }, children: _jsx(CloseCircle, { style: { color: 'black' } }) })] }) }), _jsx(Box, { sx: {
                    padding: { xs: '16px', md: '25px' },
                    overflowX: 'auto',
                    overflowY: 'auto',
                    maxHeight: 'calc(90vh - 10px)',
                    minWidth: '310px'
                }, children: _jsx(Box, { sx: { minWidth: '310px' }, children: _jsx(PrimaryGrid, { columns: columns, rows: rows }) }) })] }));
};
